import { AxiosResponse } from "axios";
import { Http } from "../../Utils/Http";
import { IAPIErrorResponse } from "../Interfaces/Base/IAPIErrorResponse";
import { IResponse } from "../Interfaces/Base/IResponse";
import { IPlano } from "../Interfaces/Request/Plano/IPlano";

export interface IPlanoAPI {
  fetchPlano(
    identifier: string
  ): Promise<AxiosResponse<IResponse<IPlano> | IAPIErrorResponse>>;
  fetchAllPlanos(): Promise<AxiosResponse<IResponse<IPlano[]>>>;
}

class PlanoAPI implements IPlanoAPI {
  async fetchAllPlanos(): Promise<AxiosResponse<IResponse<IPlano[]>>> {
    const axios = await Http.axios();
    const response = axios.get<IResponse<IPlano[]>>(`/api/planos/all-site`);
    return response;
  }
  async fetchPlano(
    identifier: string
  ): Promise<AxiosResponse<IResponse<IPlano> | IAPIErrorResponse>> {
    const axios = await Http.axios();
    const response = axios.get<IResponse<IPlano> | IAPIErrorResponse>(
      `/api/planos/info/${identifier}`
    );
    return response;
  }
}

const instance = new PlanoAPI();

export default instance;
